export enum SuggestionSortType {
    CREATION = 'creation',
    LAST_MODIFICATION = 'lastModification',
    PRIORITY = 'priority',
    STATUS = 'status'
}